// AI Voice playback — pre-recorded ElevenLabs MP3s served from /audio/{id}.mp3
// Generated once via /app/scripts/generate_voices.py using ElevenLabs multilingual_v2
// with regionally authentic Saudi / Egyptian / Levantine / Gulf voices.

import { VOICE_PROFILES, profileKey } from '@/data/voiceLines';

const audioEl = (() => {
  if (typeof window === 'undefined') return null;
  const el = new Audio();
  el.preload = 'auto';
  return el;
})();

let currentResolve = null;

export const isVoiceSupported = () => typeof window !== 'undefined' && !!window.HTMLAudioElement;

export const stopSpeaking = () => {
  if (!audioEl) return;
  try {
    audioEl.pause();
    audioEl.currentTime = 0;
  } catch (e) { /* noop */ }
  if (currentResolve) {
    const r = currentResolve;
    currentResolve = null;
    r();
  }
};

// Play a pre-recorded MP3 by audio id (no extension).
// Resolves when playback ends (or errors / stops). Never rejects.
export const playAudio = (audioId, { volume = 1, rate = 1 } = {}) =>
  new Promise((resolve) => {
    if (!audioEl || !audioId) return resolve();
    stopSpeaking();
    currentResolve = resolve;
    audioEl.src = `/audio/${audioId}.mp3`;
    audioEl.volume = Math.max(0, Math.min(1, volume));
    audioEl.playbackRate = rate;
    const cleanup = () => {
      audioEl.onended = null;
      audioEl.onerror = null;
      if (currentResolve === resolve) currentResolve = null;
      resolve();
    };
    audioEl.onended = cleanup;
    audioEl.onerror = cleanup;
    const p = audioEl.play();
    if (p && typeof p.catch === 'function') p.catch(cleanup);
  });

// Pre-warm by issuing a silent play() on an empty Audio (helps iOS Safari).
export const warmVoices = () => {
  if (!audioEl) return;
  try {
    audioEl.volume = 0;
    audioEl.src = '';
    audioEl.load();
  } catch (e) { /* noop */ }
};

export const describeVoice = ({ nationality = 'SA', gender = 'M' } = {}) => {
  const profile = VOICE_PROFILES[profileKey(nationality, gender)];
  return profile ? `${profile.label} · ${profile.name}` : 'Arabic';
};
